function f(o, r, n) {
  return o === 1 ? r : n !== void 0 ? n : r + "s";
}
export {
  f as plural
};
